// extracted by mini-css-extract-plugin
export default {"triangle":"triangle_PgIW"};